export type Point2D = [number, number];

export const computeHomography = (src: Point2D[], dst: Point2D[]) => {
  const A: number[][] = [];
  const b: number[] = [];
  for (let i = 0; i < 4; i += 1) {
    const [x, y] = src[i];
    const [u, v] = dst[i];
    A.push([x, y, 1, 0, 0, 0, -u * x, -u * y]);
    A.push([0, 0, 0, x, y, 1, -v * x, -v * y]);
    b.push(u, v);
  }
  const h = solveLinearSystem(A, b);
  if (!h) {
    return null;
  }
  return [h[0], h[1], h[2], h[3], h[4], h[5], h[6], h[7], 1];
};

const solveLinearSystem = (A: number[][], b: number[]) => {
  const n = b.length;
  const M = A.map((row, i) => [...row, b[i]]);
  for (let i = 0; i < n; i += 1) {
    let maxRow = i;
    for (let k = i + 1; k < n; k += 1) {
      if (Math.abs(M[k][i]) > Math.abs(M[maxRow][i])) {
        maxRow = k;
      }
    }
    const tmp = M[i];
    M[i] = M[maxRow];
    M[maxRow] = tmp;
    const pivot = M[i][i];
    if (Math.abs(pivot) < 1e-10) {
      return null;
    }
    for (let j = i; j <= n; j += 1) {
      M[i][j] /= pivot;
    }
    for (let k = 0; k < n; k += 1) {
      if (k === i) {
        continue;
      }
      const factor = M[k][i];
      for (let j = i; j <= n; j += 1) {
        M[k][j] -= factor * M[i][j];
      }
    }
  }
  return M.map((row) => row[n]);
};
